import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { contact } from '../data/mock';

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_a85f478b-763e-4b7e-9f54-0dbb5a37a168/artifacts/fk4lgbat_Logo%20Phocea%20Rent.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-slate-400 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_WHITE} 
                alt="Phocea Rent" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-slate-400 leading-relaxed max-w-md mb-6">
              Démocratisons l'accès aux écrans LED professionnels. 
              Location flexible, sans engagement, livrée partout en France.
            </p>
            <div className="flex gap-4">
              <div className="bg-slate-900 rounded-lg px-4 py-2 border border-[#DFFF00]/20">
                <span className="text-[#DFFF00] font-bold">500m²</span>
                <p className="text-xs text-slate-500">de stock LED</p>
              </div>
              <div className="bg-slate-900 rounded-lg px-4 py-2 border border-[#DFFF00]/20">
                <span className="text-[#DFFF00] font-bold">24-48h</span>
                <p className="text-xs text-slate-500">Validation</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: 'Nos Packs', id: 'packs' },
                { label: 'Comment ça marche', id: 'process' },
                { label: 'Avantages', id: 'advantages' },
                { label: 'FAQ', id: 'faq' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="hover:text-[#DFFF00] transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#DFFF00]" />
                <span>{contact.phone}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#DFFF00]" />
                <span>{contact.email}</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#DFFF00]" />
                <span>{contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">
              © {currentYear} Phocea Rent. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/mentions-legales" className="hover:text-[#DFFF00] transition-colors">
                Mentions légales
              </Link>
              <Link to="/cgv" className="hover:text-[#DFFF00] transition-colors">
                CGV
              </Link>
              <Link to="/confidentialite" className="hover:text-[#DFFF00] transition-colors">
                Confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
